import { render, staticRenderFns } from "./r-firefly-page.vue?vue&type=template&id=0b94ea87"
import script from "./r-firefly-page.vue?vue&type=script&lang=js"
export * from "./r-firefly-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b94ea87')) {
      api.createRecord('0b94ea87', component.options)
    } else {
      api.reload('0b94ea87', component.options)
    }
    module.hot.accept("./r-firefly-page.vue?vue&type=template&id=0b94ea87", function () {
      api.rerender('0b94ea87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/firefly/r-firefly-page.vue"
export default component.exports